<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="queryConfKey" :configAuto="configAuto" :queryHandler="queryHandler" :onConfigReady="onConfigReady" :popupHandler="popupHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        </div>
        <!--<swb-trade-voucher-search class="mb10" ref="query_model" :tradeVoucherType="tradeVoucherType" :no="no" :contractNo="contractNo" @showSearch="searchMethod"></swb-trade-voucher-search>-->

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="resultConfKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import userApi from '../../api/user'
    import tradeApi from '../../api/trade'

    import SwbTradeVoucherCheck from './TradeVoucherCheck';
    Vue.regist(SwbTradeVoucherCheck);

    // 交易单详情
    import SwbTradeVoucherDetail from './TradeVoucherDetail';
    Vue.regist(SwbTradeVoucherDetail);

    // 付款信息
    import SwbTradeVoucherPaymentInfo from './TradeVoucherPaymentInfo';
    Routes.add(SwbTradeVoucherPaymentInfo);
    // 退款信息
    import SwbTradeRefundInfo from './TradeRefundInfo';
    Routes.add(SwbTradeRefundInfo);
    // 开票信息
    import SwbTradeVoucherInvoiceInfo from './TradeVoucherInvoiceInfo';
    Routes.add(SwbTradeVoucherInvoiceInfo);
    // 交付信息
    import SwbTradeVoucherDeliverInfo from './TradeVoucherDeliverInfo';
    Vue.regist(SwbTradeVoucherDeliverInfo);

    import SwbServcPurchContractList from '../contract/ServcPurchContractList';
    Routes.add(SwbServcPurchContractList);
    import SwbIntegPurchContractList from '../contract/IntegPurchContractList';
    Routes.add(SwbIntegPurchContractList);
    import SwbServcDlgtContractList from '../contract/ServcDlgtContractList';
    Routes.add(SwbServcDlgtContractList);
    import SwbServcOrderAuthorizedTradeList from '../servcOrder/ServcOrderAuthorizedTradeList';
    Routes.add(SwbServcOrderAuthorizedTradeList);
    import SwbServcOrderIsSelfList from '../servcOrder/ServcOrderIsSelfList';
    Routes.add(SwbServcOrderIsSelfList);
    import SwbFundTransRecYjList from '../payment/FundTransRecYjList';
    Routes.add(SwbFundTransRecYjList);

    import SwbTradeVoucherSearch from './TradeVoucherSearch';
    Vue.regist(SwbTradeVoucherSearch);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    export default {
        name: 'swb-trade-voucher-list',
        path: '/trade/voucher/list',
        avlActions: 'view|view_payment|pay_finished|view_refund|view_make_out|view_deliver|audit|view_yj_charge',
        avlActionNames: '查看详情、付款信息（支付完毕）、退款信息（申请退款）、开票信息、交付信息',
        avlScopes: 'servicer',
        desc: '交易单列表',
        authen: false,
        helpArticleCode: 'servicer-trade-voucher-list',
        data: function () {
            return {
                queryConfKey: 'swb-trade-voucher-list',
                resultConfKey: 'swb-trade-voucher-list',
                configAuto: true,
                tableHeight: '300',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryKey: null,
                queryEventHanlder: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                no: this.$route.query.no || null,
                orderNo: null,
                contractNo: null,
                fromDate: null,
                toDate: null,
                tradeVoucherType: 2,
                auditStateValue: null,
                // 交易单类型
                tradeVoucherTypeList: getEnumList('tradeVoucherType'),
                userInfo: {},
                //隐含的默认排序（最好不是显示列中字段，注意：不要设置el-table 的 default-sort属性）
                sortField: null,
                sortOrder: null,
                //
                qryResultConfMap: {},
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            this.auditStateValue = getEnumInfoWith('auditState', 'name', 'AuditPass').value;
            //
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.no = no;
                this.queryModel.filterItems.no = no;
            }
            let tradeVoucherType = this.$route.query.tradeVoucherType || null;
            if(!Utils.isNoB(tradeVoucherType)) {
                this.tradeVoucherType = tradeVoucherType;
                if(tradeVoucherType === 1) {
                    this.resultConfKey = 'swb-trade-voucher-list-1';
                }
            }
            //
            this.queryModel.filterItems.tradeVoucherType = this.tradeVoucherType;
            let contractNo = this.$route.query.contractNo || null;
            if(!Utils.isNoB(contractNo)) {
                this.contractNo = contractNo;
            }
            //
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log("domHeight： " + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                let colSet = {};
                let action = {};
                if(self.tradeVoucherType === 1) {
                    colSet = {
                        'no': function (row, colName, colValue, rowIndex, colConf) {
                            let col = "";
//                            if(row.overdueFlag) {
//                                col = col + '<i class="swb-icon arrears" title="佣金欠费"></i>'
//                            }
                            let no = row.no || "";
                            col = col + '<a name="tradeVoucherDetail">' + no + '</a>';
                            return col;
                        },
                        'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                            let domHtml = '';
                            if(row.overdueFlag) {
                                domHtml = domHtml + '<a class="swb-tags swb-tags-danger swb-tags-outlined " title="佣金欠费">佣金欠费</a>'
                            }
                            return domHtml;
                        },
                        'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                            //
                            let orderNo = row.orderNo || "";
                            return '<a class="swb-btn-link">' + orderNo + '</a>';
                        },
                        'payFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let payFinished = row.payFinished ? "是" : "否";
                            //
                            return '<span>' + payFinished + '</span>';
                        },
                        'deliverFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let deliverFinished = row.deliverFinished ? "是" : "否";
                            //
                            return '<span>' + deliverFinished + '</span>';
                        },
                        'checked': function (row, colName, colValue, rowIndex, colConf) {
                            let checked = row.checked ? "是" : "否";
                            //
                            return '<span>' + checked + '</span>';
                        },
                        'makeOutFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let makeOutFinished = row.makeOutFinished ? "是" : "否";
                            //
                            return '<span>' + makeOutFinished + '</span>';
                        },
                        'cancelled': function (row, colName, colValue, rowIndex, colConf) {
                            let cancelled = row.cancelled ? "是" : "否";
                            //
                            return '<span>' + cancelled + '</span>';
                        },
                        'actions': function (row, colName, colValue, rowIndex) {
                            let btnList = [];
                            if(self.checkActionPerm('view')) {
                                btnList.push({
                                    name: 'view',
                                    text: '查看详情'
                                });
                            }
                            if(self.checkActionPerm('view_detail')) {
                                btnList.push({
                                    name: 'view_detail',
                                    text: '查看明细'
                                });
                            }
                            if(self.checkActionPerm('view_payment') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_payment',
                                    text: '付款信息'
                                });
                            }
                            if(self.checkActionPerm('view_refund') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_refund',
                                    text: '退款信息'
                                });
                            }
                            if(self.checkActionPerm('view_make_out') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_make_out',
                                    text: '开票信息'
                                });
                            }
                            if(self.checkActionPerm('view_deliver') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_deliver',
                                    text: '交付信息'
                                });
                            }
                            if(self.checkActionPerm('audit', row.auditorPostId) && row.applyState == 1 && row.auditState != 1 && row.manualFlag) {
                                btnList.push({
                                    name: 'audit',
                                    text: '审核'
                                });
                            }
                            if(self.checkActionPerm('view_yj_charge') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_yj_charge',
                                    text: '佣金计费信息'
                                });
                            }
                            return btnList;
                        }
                    };
                    action = {
                        'no': function (row, colName, colValue, rowIndex, btnName) {
                            self.tradeVoucherDetail(row.id);
                        },
                        'orderNo': function (row, colName, colValue, rowIndex, btnName) {
                            //
                            self.searchServcOrder(row.orderNo, row.contractId)
                        },
                        'actions': function (row, colName, colValue, rowIndex, btnName) {
                            if(btnName === 'view') {
                                self.tradeVoucherDetail(row.id);
                            } else if(btnName === 'view_detail') {
                                self.bizItemDetail(row.id, row.contractId);
                            } else if(btnName === 'view_payment') {
                                self.tradeVoucherPaymentInfo(row);
                            } else if(btnName === 'view_refund') {
                                self.tradeRefundInfo(row);
                            } else if(btnName === 'view_make_out') {
                                self.invoiceInfo(row);
                            } else if(btnName === 'audit') {
                                self.auditTradeVoucher(row);
                            } else if(btnName === 'view_yj_charge'){
                                self.toYjRec(row)
                            }
                        }
                    };
                } else if(self.tradeVoucherType === 2) {
                    colSet = {
                        'no': function (row, colName, colValue, rowIndex, colConf) {
                            let col = "";
                            if(row.overdueFlag) {
                                col = col + '<i class="swb-icon arrears" title="佣金欠费"></i>'
                            }
                            let no = row.no || "";
                            col = col + '<a name="tradeVoucherDetail">' + no + '</a>';
                            return col;
                        },
                        'contractNo': function (row, colName, colValue, rowIndex, colConf) {
                            let contractNo = row.contractNo || "";
                            return '<a class="swb-btn-link">' + contractNo + '</a>';
                        },

                        'payFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let payFinished = row.payFinished ? "是" : "否";
                            //
                            return '<span>' + payFinished + '</span>';
                        },
                        'deliverFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let deliverFinished = row.deliverFinished ? "是" : "否";
                            //
                            return '<span>' + deliverFinished + '</span>';
                        },
                        'checked': function (row, colName, colValue, rowIndex, colConf) {
                            let checked = row.checked ? "是" : "否";
                            //
                            return '<span>' + checked + '</span>';
                        },
                        'makeOutFinished': function (row, colName, colValue, rowIndex, colConf) {
                            let makeOutFinished = row.makeOutFinished ? "是" : "否";
                            //
                            return '<span>' + makeOutFinished + '</span>';
                        },
                        'actions': function (row, colName, colValue, rowIndex) {
                            let btnList = [];

                            if(self.checkActionPerm('view')) {
                                btnList.push({
                                    name: 'view',
                                    text: '查看详情'
                                });
                            }
                            if(self.checkActionPerm('view_payment') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_payment',
                                    text: '付款信息'
                                });
                            }
                            if(self.checkActionPerm('view_refund') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_refund',
                                    text: '退款信息'
                                });
                            }
                            if(self.checkActionPerm('view_make_out') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_make_out',
                                    text: '开票信息'
                                });
                            }
                            if(self.checkActionPerm('view_deliver') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_deliver',
                                    text: '交付信息'
                                });
                            }
                            if(self.checkActionPerm('audit', row.auditorPostId) && row.applyState == 1 && row.auditState != 1 && row.manualFlag) {
                                btnList.push({
                                    name: 'audit',
                                    text: '审核'
                                });
                            }
                            if(self.checkActionPerm('view_yj_charge') && !row.cancelled) {
                                btnList.push({
                                    name: 'view_yj_charge',
                                    text: '佣金计费信息'
                                });
                            }
                            return btnList;
                        }
                    };
                    action = {
                        'no': function (row, colName, colValue, rowIndex, btnName) {
                            self.tradeVoucherDetail(row.id);
                        },
                        'contractNo': function (row, colName, colValue, rowIndex, btnName) {
                            //
                            self.searchContact(row.contractNo, row.contractType);
                        },
                        'actions': function (row, colName, colValue, rowIndex, btnName) {
                            if(btnName === 'view') {
                                self.tradeVoucherDetail(row.id);
                            } else if(btnName === 'view_payment') {
                                self.tradeVoucherPaymentInfo(row);
                            } else if(btnName === 'view_refund') {
                                self.tradeRefundInfo(row);
                            } else if(btnName === 'view_make_out') {
                                self.invoiceInfo(row);
                            } else if(btnName === 'view_deliver') {
                                self.deliverInfo(row);
                            }else if(btnName === 'audit') {
                                self.auditTradeVoucher(row)
                            }else if(btnName === 'view_yj_charge') {
                                self.toYjRec(row)
                            }
                        }
                    };
                }
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */colSet, /* 单元格按钮点击处理函数 */action);
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            popupHandler: function (fieldCode, curValue, curText) {
            },
            onConfigReady: function () {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                if(!Utils.isNoB(this.no)) {
                    let data = {value: this.no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                if(!Utils.isNoB(this.tradeVoucherType)) {
                    let data = {value: this.tradeVoucherTyp};
                    let fieldInfo = {};
                    fieldInfo["tradeVoucherType"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                if(!Utils.isNoB(this.contractNo)) {
                    let data = {value: this.contractNo};
                    let fieldInfo = {};
                    fieldInfo["contractNo"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                //
                this.queryEventHanlder = function (itemCode, eventName, itemValue, filterItems) {

                    if(eventName == 'change') {
                        //
                        if(itemCode == 'tradeVoucherType') {
                            let tradeVoucherTypeInfo = getEnumInfoWith('tradeVoucherType', 'value', itemValue);
                            let targetContractNo = {};
                            if(tradeVoucherTypeInfo.name == 'GeneralVoucher') {
                                targetContractNo["contractNo"] = {hidden: true};
                                query_model_ctrl.updateFields(targetContractNo);
                                //
                                targetContractNo["orderNo"] = {hidden: true};
                                query_model_ctrl.updateFields(targetContractNo);
                                //
                                self.resultConfKey = 'swb-trade-voucher-list';
                            } else {
                                targetContractNo["contractNo"] = {hidden: false};
                                query_model_ctrl.updateFields(targetContractNo);
                                //
                                targetContractNo["orderNo"] = {hidden: false};
                                query_model_ctrl.updateFields(targetContractNo);
                                //
                                self.resultConfKey = 'swb-trade-voucher-list-1';
                            }
                            //
                            self.tradeVoucherType = itemValue;
                            self.totalCount = 0;
                            self.queryModel.filterItems = Utils.merge({}, filterItems);
                            self.queryHandler(self.queryModel);
                        }
                    }
                };
            },
            queryHandler: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.handlePageChange(1);
            },
            //
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            // 起始时间变化事件
            fromDateChange: function (val) {
                if(!Utils.isNoB(this.toDate)) {
                    let endDate = this.toDate.format("yyyy-MM-dd");
                    if(endDate < val) {
                        MsgBox.warning("起始时间不能大于结束时间");
                        this.fromDate = null;
                    }
                }
            },
            // 结束时间变化事件
            endDateChange: function (val) {
                if(!Utils.isNoB(this.fromDate)) {
                    let startDate = this.fromDate.format("yyyy-MM-dd");
                    if(startDate > val) {
                        MsgBox.warning("结束时间不能小于起始时间");
                        this.toDate = null;
                    }
                }
            },
            // 当前登录信息
            getCurrentUserInfo: function () {
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        self.userInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 分页相关
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getTradeVoucherList();
            },
            //处理排序事件
            sortListData(sortInfo){
                this.sortField = sortInfo.prop;
                this.sortOrder = sortInfo.order;
                //
                this.getTradeVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getTradeVoucherList();
            },
            // 交易单列表
            getTradeVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                tradeApi.getTradeVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        let tradeVoucherList = data.rows;
                        if(!Utils.isNoB(tradeVoucherList) && tradeVoucherList.length > 0) {
                            let auditState = getEnumMap("auditState", "value2text");
                            for(let i = 0; i < tradeVoucherList.length; i++) {
                                let tradeVoucher = tradeVoucherList[i];
                                let failState = getEnumInfoWith('auditState', 'name', 'AuditFail');
                                let passState = getEnumInfoWith('auditState', 'name', 'AuditPass');
                                if(auditState[tradeVoucher.auditState] == passState.text) {
                                    tradeVoucher.auditStateText = "通过";
                                } else if(auditState[tradeVoucher.auditState] == failState.text) {
                                    tradeVoucher.auditStateText = "未通过";
                                } else {
                                    tradeVoucher.auditStateText = "未审核";
                                }
                                //
                                let tradeType = getEnumInfoWith('tradeType', 'value', tradeVoucher.type);
                                if(tradeType != null) {
                                    tradeVoucher.typeText = tradeType.text;
                                }
                                //
                                let estmtAmount = tradeVoucher.estmtAmount;
                                if(!Utils.isNoB(estmtAmount)) {
                                    tradeVoucher.estmtAmount = estmtAmount.toFixed(2);
                                } else {
                                    tradeVoucher.estmtAmount = '0.00';
                                }
                                let amountPay = tradeVoucher.amountPay;
                                if(!Utils.isNoB(amountPay)) {
                                    tradeVoucher.amountPay = amountPay.toFixed(2);
                                } else {
                                    tradeVoucher.amountPay = '0.00';
                                }
                                let trackPaidAmount = tradeVoucher.trackPaidAmount;
                                if(!Utils.isNoB(trackPaidAmount)) {
                                    tradeVoucher.trackPaidAmount = trackPaidAmount.toFixed(2);
                                } else {
                                    tradeVoucher.trackPaidAmount = '0.00';
                                }
                            }
                        }
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(tradeVoucherList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看详情
            tradeVoucherDetail: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '交易单 - 查看详情',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 700,
                    height: 520,
                    template: '<div>' +
                    '<swb-trade-voucher-detail :tradeId="id" :tradeVoucherType="tradeVoucherType" ref="swb_trade_voucher_detail"></swb-trade-voucher-detail>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: null,
                        tradeVoucherType: null
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                            this.id = id;
                            this.tradeVoucherType = self.tradeVoucherType;
                        }
                    }
                });
            },
            // 付款信息
            tradeVoucherPaymentInfo: function (row) {
                this.$router.push({
                    query: {tradeId: row.id},
                    path: SwbTradeVoucherPaymentInfo.path
                });
            },
            // 退款信息
            tradeRefundInfo: function (row) {
                this.$router.push({
                    query: {tradeId: row.id},
                    path: SwbTradeRefundInfo.path
                });
            },
            // 开票信息
            invoiceInfo: function (row) {
                this.$router.push({
                    query: {tradeId: row.id},
                    path: SwbTradeVoucherInvoiceInfo.path
                });
            },
            // 交付信息
            deliverInfo: function (row) {
                let self = this;
                let okText = '';
                if(!row.closed && row.fullfilled) {
                    okText = '关闭交易';
                } else {
                    okText = '确定';
                }
                Vue.$showDialog({
                    title: '交易单 - 交付信息',
                    showCloseBtn: true,
                    okText: okText,
                    width: 500,
                    height: 400,
                    template: '<div>' +
                    '<swb-trade-voucher-deliver-info :tradeId="id" :okText="okTextStr" ref="swb_trade_voucher_deliver"></swb-trade-voucher-deliver-info>' +
                    '</div>',
                    data: {
                        okTextStr: null,
                        id: null,
                    },
                    methods: {},
                    okClicked: function () {
                        if(okText == '关闭交易') {
                            let result = this.$refs.swb_trade_voucher_deliver.getDlgResult() || {};
                            if(result != null && result.type === 'info') {
                                let reminderFlag = result.message;
                                if(!Utils.isNoB(reminderFlag)) {
                                    self.$confirm(reminderFlag, '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(function () {
                                        let trade = result.data;
                                        let postData = {};
                                        postData.id = trade.id;
                                        //
                                        let msgBoxDlg = MsgBox.loading();
                                        tradeApi.closeTradeVoucher(postData, function (result) {
                                            msgBoxDlg.close();
                                            if(result.type === "info") {
                                                MsgBox.success("操作成功");
                                                self.getTradeVoucherList();
                                                return true;
                                            } else {
                                                MsgBox.warning(result.message);
                                                return false;
                                            }
                                        });
                                    }).catch(function () {
                                    });
                                }
                            } else {
                                MsgBox.warning(result.message);
                                return false;
                            }
                        }
                    },
                    lifecycle: {
                        created: function () {
                            this.id = row.id;
                            this.okTextStr = okText;
                        }
                    }
                });
            },
            //审核交易单
            auditTradeVoucher: function (row) {
                let self = this;
                if(!Utils.isNoB(self.userInfo) && self.userInfo.userId == row.creatorId) {
                    MsgBox.warning("本人不能进行该审核操作！");
                } else {
                    Vue.$showDialog({
                        title: '交易单 - 审核',
                        showCloseBtn: true,
                        width: '30%',
                        height: '90%',
                        template: '<div>' +
                        '<swb-trade-voucher-check :id="id" ref="swb_trade_voucher_check"></swb-trade-voucher-check>' +
                        '</div>',
                        data: {
                            id: null
                        },
                        methods: {},
                        okClicked: function () {
                            let result = this.$refs.swb_trade_voucher_check.getDlgResult() || {};
                            if(result != null && result.type === 'info') {
                                let postData = result.data;
                                //
                                let msgBoxDlg = MsgBox.loading();
                                tradeApi.auditTradeVoucher(postData, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type === "info") {
                                        MsgBox.success("审核成功");
                                        self.getTradeVoucherList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                MsgBox.warning("返回错误");
                            }
                        },
                        lifecycle: {
                            created: function () {
                                this.id = row.id;
                            }
                        }
                    });
                }
            },
            // 跳转佣金计费单列表
            toYjRec: function (row) {
                this.$router.push({
                    path: SwbFundTransRecYjList.path,
                    query: {tradeNo: row.no}
                })
            },
            // 跳转到合同页面
            searchContact: function (contractNo, contractType) {
                let contractTypeInfo = getEnumInfoWith('contractType', 'value', contractType);
                if(!Utils.isNoB(contractTypeInfo)) {
                    if(contractTypeInfo.name == 'ServcPurch') {
                        this.$router.push({
                            path: SwbServcPurchContractList.path,
                            query: {
                                no: contractNo,
                            }
                        })
                    } else if(contractTypeInfo.name == 'IntegPurch') {
                        this.$router.push({
                            path: SwbIntegPurchContractList.path,
                            query: {
                                no: contractNo,
                            }
                        })
                    } else if(contractTypeInfo.name == 'ServcDlgt') {
                        this.$router.push({
                            path: SwbServcDlgtContractList.path,
                            query: {
                                no: contractNo,
                            }
                        })
                    }
                }
            },
            // 跳转到订单列表
            searchServcOrder: function (orderNo, contractId) {
                if(Utils.isNoB(contractId)) {
                    this.$router.push({
                        path: SwbServcOrderAuthorizedTradeList.path,
                        query: {
                            no: orderNo,
                        }
                    })
                } else {
                    this.$router.push({
                        path: SwbServcOrderIsSelfList.path,
                        query: {
                            no: orderNo,
                        }
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherList.vue